import AxiosManager from "../_axiosManager";

export async function postLogin(body: any) {
  const res = await AxiosManager.getInstance().post("/auth/admin/login", body);

  return res;
}
